import React from "react";
import swal from "sweetalert";

const RolesAndPermissionsTable = (props) => {
    const capitalizeFirstLetter = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const handleChange = (checked, id) => {
        if (props.paddleLock == false) {
            const [role, permission] = id.split('__');
            let newRole = '';
            if (role == 'super_admin') {
                newRole = 1;
            } else if (role == 'store_admin') {
                newRole = 2;
            } else if (role == 'customer_support_admin') {
                newRole = 3;
            } else if (role == 'area_manager') {
                newRole = 4;
            } else if (role == 'user') {
                newRole = 100;
            }

            props.givePermission(checked, permission, newRole);

        } else {
            swal("Please disable paddle lock to change permission", {
                icon: "warning",
                buttons: false,
                timer: 3000
            })
        }
    }

    let dontShowCheckbox = [
        'area managers',
        'create area managers',
        'view area managers',
        'edit area managers',
        'delete area managers',
        'Activate/Deactivate area managers',
        'users',
        'create users',
        'view users',
        'edit users',
        'delete users',
        'Activate/Deactivate users',
        'roles and permission',
    ];

    const enableCheckMarkForSuperAdmin = [
        'country specific search',
        'country specific search ticked',
        'receive promotional emails - opt in by default'
    ];

    const imageAppear = (image) => {
        if(image == '' || image == null) {
            return;
        }
        document.getElementById('permissionImage').style.visibility = "visible";
        document.getElementById('permissionImage').setAttribute('src', image);
    }

    const imageDisappear = () => {
        document.getElementById('permissionImage').style.visibility = "hidden";
        document.getElementById('permissionImage').removeAttribute('src');
    }

    const removeSpace = (str) => {
        return str.replace(/\s/g, '');
    }

    const checkButton = () => {
        return (
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" version="1" viewBox="0 0 48 48" enableBackground="new 0 0 48 48" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><polygon fill="#43A047" points="40.6,12.1 17,35.7 7.4,26.1 4.6,29 17,41.3 43.4,14.9"></polygon></svg>
        )
    }

    const cancelButton = () => {
        return (
            <svg stroke="currentColor" fill="currentColor" strokeWidth="0" version="1" viewBox="0 0 48 48" enableBackground="new 0 0 48 48" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path fill="#D50000" d="M24,6C14.1,6,6,14.1,6,24s8.1,18,18,18s18-8.1,18-18S33.9,6,24,6z M24,10c3.1,0,6,1.1,8.4,2.8L12.8,32.4 C11.1,30,10,27.1,10,24C10,16.3,16.3,10,24,10z M24,38c-3.1,0-6-1.1-8.4-2.8l19.6-19.6C36.9,18,38,20.9,38,24C38,31.7,31.7,38,24,38 z"></path></svg>
        )
    }

    let rows = [];

    props.permissionLists.forEach((permission, index) => {
        let id = removeSpace(permission.permissionName);
        const shouldRenderCheckbox = !dontShowCheckbox.includes(permission.permissionName);
        const enableCheckForSuperAdmin = enableCheckMarkForSuperAdmin.includes(permission.permissionName); 
        rows.push(
            <React.Fragment key={index}>
                <tr key={id}>
                    <td
                        onMouseOver={() => imageAppear(permission.image)}
                        onMouseOut={() => imageDisappear()}
                        style={{ paddingLeft: `${permission.spacing * 20 + 5}px` }} >

                        {capitalizeFirstLetter(permission.permissionName)}
            
                    </td>
                    <td>
                        <React.Fragment>
                            {permission.roles.includes('super_admin') ?
                                enableCheckForSuperAdmin ?
                                <a onClick={() => handleChange(false, `super_admin__${permission.permissionId}`)}>
                                    {checkButton()}
                                </a>
                                :
                                checkButton()
                                :
                                enableCheckForSuperAdmin ?
                                <a onClick={() => handleChange(true, `super_admin__${permission.permissionId}`)}>
                                    {cancelButton()}
                                </a>
                                :
                                cancelButton()
                            }
                        </React.Fragment>
                    </td>
                    <td style={!shouldRenderCheckbox ? {backgroundColor: 'grey'} : {}}>
                        {shouldRenderCheckbox && (
                            <React.Fragment>
                                {permission.roles.includes('area_manager') ?
                                    <a onClick={() => handleChange(false, `area_manager__${permission.permissionId}`)}>
                                        {checkButton()}
                                    </a>
                                    :
                                    <a onClick={() => handleChange(true, `area_manager__${permission.permissionId}`)}>
                                        {cancelButton()}
                                    </a>
                                }
                            </React.Fragment>
                        )}
                    </td>
                    <td style={!shouldRenderCheckbox ? {backgroundColor: 'grey'} : {}}>
                        {shouldRenderCheckbox && (
                            <React.Fragment>
                                {permission.roles.includes('customer_support_admin') ?
                                    <a onClick={() => handleChange(false, `customer_support_admin__${permission.permissionId}`)}>
                                        {checkButton()}
                                    </a>
                                    :
                                    <a onClick={() => handleChange(true, `customer_support_admin__${permission.permissionId}`)}>
                                        {cancelButton()}
                                    </a>
                                }
                            </React.Fragment>
                        )}
                    </td>
                    <td style={!shouldRenderCheckbox ? {backgroundColor: 'grey'} : {}}>
                        {shouldRenderCheckbox && (
                            <React.Fragment>
                                {permission.roles.includes('store_admin') ?
                                    <a onClick={() => handleChange(false, `store_admin__${permission.permissionId}`)}>
                                        {checkButton()}
                                    </a>
                                    :
                                    <a onClick={() => handleChange(true, `store_admin__${permission.permissionId}`)}>
                                        {cancelButton()}
                                    </a>
                                }
                            </React.Fragment>
                        )}
                    </td>
                    <td style={!shouldRenderCheckbox ? {backgroundColor: 'grey'} : {}}>
                        {shouldRenderCheckbox && (
                            <React.Fragment>
                                {permission.roles.includes('user') ?
                                    <a onClick={() => handleChange(false, `user__${permission.permissionId}`)}>
                                        {checkButton()}
                                    </a>
                                    :
                                    <a onClick={() => handleChange(true, `user__${permission.permissionId}`)}>
                                        {cancelButton()}
                                    </a>
                                }
                            </React.Fragment>
                        )}
                    </td>
                </tr>
            </React.Fragment>
        );
    });


    return (
        <div>
            <img
                id='permissionImage'
                style={{
                    position: 'fixed',
                    top: '50%',
                    left: '60%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: 9999,
                    visibility: 'hidden',
                    width: '50%',
                    height: '50%',
                    border: '1px solid'
                }}
            />
            <div style={{ height: '700px', overflowY: 'auto' }}>
                <table id="custom" name="custome" style={{ backgroundColor: "white" }}>
                    <thead>
                        <tr>
                            <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Permissions</th>
                            <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Super Admin</th>
                            <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Area Manager</th>
                            <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>CS Admin</th>
                            <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Store Admin</th>
                            <th style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 999, verticalAlign: 'top' }}>Store Users</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows}
                        {props.permissionLists.length === 0 && (
                            <tr>
                                <td colSpan="6">No results founds.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

        </div>
    );
}

export default RolesAndPermissionsTable;